import { useNavigate } from "react-router-dom";
import earring from '../pics/earring.png'

function ImageBox(props){

    const { id, name,src,price, productName,subImages, onClick} = props
    //console.log(name)
    return(
         <div className="imageBox flex column shadow" onClick={onClick}>
              <div className="flex three center">
                <img src={src} className='col-img' id="col-img"></img>
              </div>
              <div className="flex one center">
                <p className="remove small-txt">{name}</p>
              </div>
              <div className="flex one center">
                 <p className="remove small-txt">{price}</p>
              </div>
         </div>
    )
}

export default ImageBox;